import BrowseDeviationSelector from './BrowseDeviationSelector';

export default BrowseDeviationSelector;
